import React from "react";
import { Table, InputNumber, Form, ColorPicker, Space } from "antd";
import get from "lodash/get";
import {
  validatePartBasedPartWeight,
} from "../../../utilities/shift";

const PartCNCSettings = ({ name, partsData, form, config }) => {

  if (!get(partsData, "length")) return null;

  const columns = [
    {
      title: "Part Name",
      dataIndex: "name",
      width: 200,
      render: (_, record) => (
        <p className="inline-block">
          <p className="text-xs break-words">{get(record, "name", "--")}</p>
          {get(record, "item_id") && (
            <p className="text-xs break-words">{get(record, "item_id", "--")}</p>
          )}
        </p>
      ),
    },
    {
      title: "No of operations",
      dataIndex: ["meta", "machining_cycle"],
      align:"center",
      width: 100,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "machining_cycle"]}
          rules={[{ required: true, message: "No of operations is required" }]}
        >
          <InputNumber
            className="w-full"
            placeholder="No of operations"
            size="small"
            defaultValue={0}
          />
        </Form.Item>
      ),
    },
    {
      title: "Planned Production",
      dataIndex: ["meta", "planned_production"],
      align:"center",
      width: 110,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[
            name,
            "parts_full",
            rowIndex,
            "meta",
            "planned_production",
          ]}
          rules={[{ required: true, message: "Planned production required" }, { type: "number", min: 1, message: "Planned production should be greater than 1" }]}
        >
          <InputNumber
            className="w-full"
            placeholder="Count"
            size="small"
            defaultValue={0}
            onChange={(value) => {
              form.setFieldValue(
                [
                  "components",
                  name,
                  "parts_full",
                  rowIndex,
                  "meta",
                  "planned_production",
                ],
                value
              );
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: "Rejected Count",
      dataIndex: ["meta", "rejected_count"],
      align:"center",
      width: 100,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "rejected_count"]}
        >
          <InputNumber
            placeholder="Rejected count"
            className="w-full"
            size="small"
            defaultValue={0}
          />
        </Form.Item>
      ),
    },
    {
      title: "Raw Weight (gm)",
      dataIndex: ["meta", "raw_weight"],
      align:"center",
      width: 150,
      render: (_, __, rowIndex) => (
        <Form.Item name={[name, "parts_full", rowIndex, "meta", "raw_weight"]}>
          <InputNumber
            className="w-full"
            placeholder="Raw weight"
            addonAfter="gm"
            size="small"
            defaultValue={0}
            precision={2}
          />
        </Form.Item>
      ),
    },
    {
      title: "Finished Weight (gm)",
      dataIndex: ["meta", "finished_weight"],
      align:"center",
      width: 150,
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "finished_weight"]}
          rules={[validatePartBasedPartWeight(name, rowIndex,'raw_weight')]}
        >
          <InputNumber
            className="w-full"
            placeholder="Finished weight"
            addonAfter="gm"
            size="small"
            defaultValue={0}
            precision={2}
          />
        </Form.Item>
      ),
    },
    {
      title: "Job / Contratual / Profit Cost",
      dataIndex: ["meta", "costings"],
      minWidth: 200,
      render: (_, __, rowIndex) => (
        <Space.Compact>
          <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "job_cost_per_pc"]} label="" >
            <InputNumber placeholder="Job"
              style={{ width: "100%" }} size="small"
              prefix="₹"
              defaultValue={0}
            />
          </Form.Item>

          <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "contractual_cost_per_pc"]} label="">
            <InputNumber placeholder="Contratual"
              style={{ width: "100%" }} size="small"
              prefix="₹"
              defaultValue={0}
            />
          </Form.Item>

          <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "profit_per_pc"]} label="">
            <InputNumber placeholder="Profit"
              style={{ width: "100%" }} size="small"
              prefix="₹"
              defaultValue={0}
            />
          </Form.Item>
        </Space.Compact>
      ),
    },
       {
          title: "Units / box",
          align:"center",
          dataIndex: ["meta", "units_per_box"],
          render: (_, __, rowIndex) => (
            <Form.Item
              name={[name, "parts_full", rowIndex, "meta", "units_per_box"]}
              rules={[
            {
              required: true,
              message: "Please Enter Units Per Box...!",
            },
            {
              type: "number",
              min: 1,
              message: "Units Per Box must be at least 1",
            },
          ]}
            >
              <InputNumber
                className="w-full"
                placeholder="Units Per Box"
                size="small"
                defaultValue={1}
              />
            </Form.Item>
          ),
        },
    {
      title: "Color",
      align:"center",
      dataIndex: ["meta", "color"],
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "color"]}
          getValueFromEvent={(color) => {
            if (
              typeof color === "object" &&
              color !== null &&
              typeof color.toHexString === "function"
            ) {
              return color.toHexString();
            }
            return color;
          }}
        >
          <ColorPicker size="small" disabledAlpha format="rgb" />
        </Form.Item>
      ),
    },
     
  ];

  return (
    <Table
      size="small"
     rowKey={(record) => get(record, "id") || crypto.randomUUID()}
      pagination={false}
      dataSource={partsData}
      columns={columns}
      scroll={{ x: true }}
      bordered
      onHeaderRow={(columns, index) => {
        return {
          className: "text-xs",
        };
      }}
      onRow={() => {
        return {
          className: "text-xs",
        };
      }}
    />
  );
};
export default PartCNCSettings;
